var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.5 906.3c-16 0-35.7-11.4-43.7-25.2L71.4 537.4c-8-13.9-8-36.6 0-50.5l198.4-343.6c8-13.9 27.7-25.2 43.7-25.2h396.8c16 0 35.7 11.4 43.7 25.2l198.4 343.6c8 13.9 8 36.6 0 50.5L754 881c-8 13.9-27.7 25.2-43.7 25.2H313.5z",
    fill: "#FF1111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.1 828.7h365.5l182.8-316.6-182.8-316.5H329.1L146.4 512.2l182.7 316.5z m374 29.2H320.7c-5.2 0-10-2.8-12.6-7.3L116.9 519.5c-2.6-4.5-2.6-10.1 0-14.6l191.2-331.1c2.6-4.5 7.4-7.3 12.6-7.3h382.4c5.2 0 10 2.8 12.6 7.3l191.2 331.1c2.6 4.5 2.6 10.1 0 14.6L715.7 850.6c-2.6 4.5-7.4 7.3-12.6 7.3z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8 558.4c-2.7-1.9-4.5-5.1-4.5-8.9 0-6.1 4.9-10.8 11-10.8 3.2 0 5.3 0.9 6.8 2.1 11 8.7 22.7 13.6 37.1 13.6s23.5-6.8 23.5-16.7v-0.4c0-9.5-5.3-14.6-29.9-20.3-28.2-6.8-44.1-15.2-44.1-39.6v-0.4c0-22.7 18.9-38.5 45.3-38.5 16.7 0 30.1 4.4 42.1 12.3 2.7 1.5 5.1 4.7 5.1 9.3 0 6.1-4.9 10.8-11 10.8-2.3 0-4.2-0.6-6.1-1.7-10.2-6.6-20.1-10-30.5-10-13.6 0-21.6 7-21.6 15.7v0.4c0 10.2 6.1 14.8 31.6 20.8 28 6.8 42.4 16.9 42.4 38.8v0.4c0 24.8-19.5 39.6-47.4 39.6-18 0.2-35.1-5.5-49.8-16.5zM419.2 462.2H387c-6.1 0-10.8-4.9-10.8-10.8s4.7-10.8 10.8-10.8h88c5.9 0 10.6 4.9 10.6 10.8s-4.7 10.8-10.6 10.8h-32.4v100.4c0 6.4-5.3 11.6-11.7 11.6-6.4 0-11.7-5.1-11.7-11.6V462.2zM610.5 507.3v-0.4c0-25.8-18.8-47.2-45.1-47.2s-44.7 21-44.7 46.8v0.4c0 25.8 18.8 47 45.1 47s44.7-20.8 44.7-46.6z m-114.2 0v-0.4c0-37.3 28.8-68.6 69.5-68.6s69.1 30.9 69.1 68.2v0.4c0 37.3-28.8 68.6-69.5 68.6s-69.1-30.9-69.1-68.2zM713.5 509.6c17.6 0 28.6-9.9 28.6-23.7v-0.4c0-15.5-11.2-23.7-28.6-23.7h-27.1v47.7l27.1 0.1z m-50.4-57.2c0-6.6 5.1-11.7 11.7-11.7h40.5c31.1 0 50.4 17.6 50.4 44.3v0.4c0 29.7-23.9 45.3-53 45.3h-26.3v32c0 6.4-5.1 11.6-11.6 11.6-6.6 0-11.7-5.1-11.7-11.6V452.4z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSign);
export default __webpack_public_path__ + "static/media/stop-sign.b2ef321663159a93530c67052471c5b1.svg";
export { ForwardRef as ReactComponent };